import type { FC } from "react";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "@privacy/translations";
import { ChevronsLeftIcon } from "../../shared/icons";
import type { SidebarState } from "./Sidebar";
import type { SxProps, Theme } from "@mui/material/styles";

type ToggleSidebarButtonProps = {
  id: string;
  state: SidebarState;
  onChange: (newState: SidebarState) => void;
  sx?: SxProps<Theme>;
};

export const ToggleSidebarButton: FC<ToggleSidebarButtonProps> = ({ id, state, onChange, sx }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      disableFocusRipple
      aria-label={t(state === "expanded" ? "Sidebar.CollapsedMenu" : "Sidebar.ExpandedMenu")}
      id={id}
      sx={{
        "bgcolor": theme => theme.palette.background.paper,
        "borderRadius": 1,
        "height": 30,
        "width": 30,
        "boxShadow": theme => theme.shadows[1],
        "border": `1px solid`,
        "borderColor": theme => theme.palette.divider,
        "&:hover": { bgcolor: theme => theme.palette.background.paper },
        "&:after": { content: '""', position: "absolute", inset: 0, transform: "scaleY(3) scaleX(2)" },
        ...sx,
      }}
      onClick={() => onChange(state === "expanded" ? "collapsed" : "expanded")}
    >
      <ChevronsLeftIcon size={14} rotate={state === "expanded" ? 0 : 180} />
    </IconButton>
  );
};
